// src/config/index.js
const PROD_API = 'https://pick-app-backend-service-581390514173.us-central1.run.app';
const STAGING_API = 'https://pick-app-backend-staging-service-581390514173.us-central1.run.app';

export const config = {
  apiUrl: process.env.REACT_APP_API_URL || (
    process.env.REACT_APP_ENVIRONMENT === 'staging'
      ? STAGING_API
      : PROD_API
  )
};

// // frontend/src/config/index.js
// const PROD_API = 'https://pick-app-backend-service-581390514173.us-central1.run.app';
// const STAGING_API = 'https://pick-app-backend-staging-service-581390514173.us-central1.run.app';

// export const config = {
//   apiUrl:
//     process.env.NODE_ENV === 'production'
//       ? process.env.REACT_APP_ENVIRONMENT === 'staging'
//         ? STAGING_API
//         : PROD_API
//       : process.env.REACT_APP_API_URL
// };
// frontend/src/config/index.js

// // hard‐coded production URL
// const PROD_API = 'https://pick-app-backend-service-581390514173.us-central1.run.app';

// export const config = {
//   // in dev/staging, use whatever you’ve set in .env; in prod, fall back to PROD_API
//   apiUrl:
//     process.env.NODE_ENV === 'production'
//       ? PROD_API
//       : process.env.REACT_APP_API_URL
// };


// export const config = {
//   apiUrl: process.env.REACT_APP_API_URL
// };


// src/config/index.js
// export const config = {
//   apiUrl: process.env.NODE_ENV === 'development' 
//     ? 'http://127.0.0.1:8080'
//     : 'https://pick-app-backend-service-581390514173.us-central1.run.app'
// };